// Akay wordmark logo — premium serif with italicized accent letter
export default function Logo({ size = "md", showTag = true, tag = "Liège · Limbourg" }) {
  const sizes = {
    sm: { name: "text-xl", tag: "text-[9px]" },
    md: { name: "text-2xl", tag: "text-[10px]" },
    lg: { name: "text-3xl", tag: "text-[11px]" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="flex items-center gap-3" data-testid="akay-logo">
      <span className={`font-serif ${s.name} tracking-tight font-light leading-none`}>
        Ak<span className="italic font-normal text-[hsl(var(--accent))]">a</span>y
      </span>
      {showTag && (
        <>
          <span className="hidden sm:inline-block w-6 h-px bg-[hsl(var(--accent))]/40" />
          <span className={`hidden sm:inline ${s.tag} uppercase tracking-[0.3em] text-muted-foreground`}>
            {tag}
          </span>
        </>
      )}
    </div>
  );
}
